import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { ValueNumbers } from './components/ValueNumbers';
import { Problem } from './components/Problem';
import { HowItWorks } from './components/HowItWorks';
import { Gallery } from './components/Gallery';
import { Variety } from './components/Variety';
import { UseCases } from './components/UseCases';
import { Comparison } from './components/Comparison';
import { PrintRights } from './components/PrintRights';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3iiweonbohg2p">
      <noscript data-id="element-1" data-mp="3mljat0fdtn5p">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3ml14faz09sk2" />
      </noscript>
      <SiteHeader data-id="element-3" data-mp="4wwnrzgd0hb" />
      <main data-id="element-4" data-mp="5ggxfcks0yi">
        <Hero data-id="element-5" data-mp="82kz509bybz" />
        <ValueNumbers data-id="element-6" data-mp="7sxpp6lk59z" />
        <Problem data-id="element-7" data-mp="2zlldgx6hkckm" />
        <HowItWorks data-id="element-8" data-mp="2zm4wkh7vh708" />
        <Gallery data-id="element-9" data-mp="2zmo5x9jgin2n" />
        <Variety data-id="element-10" data-mp="2zn6cp03qwjot" />
        <UseCases data-id="element-11" data-mp="33mowfsjtyoq2" />
        <Comparison data-id="element-12" data-mp="33m5eibu6k0c1" />
        <PrintRights data-id="element-13" data-mp="33ngf62sbwryx" />
        <Bonuses data-id="element-14" data-mp="33mykvbp88ntn" />
        <Testimonials data-id="element-15" data-mp="33oi1x4ipj2wh" />
        <OfferStack data-id="element-16" data-mp="38l8hzruihyhw" />
        <Guarantee data-id="element-17" data-mp="38kqce4lym7xb" />
        <Faq data-id="element-18" data-mp="38k6vmr81ppkv" />
        <FinalOffer data-id="element-19" data-mp="38nup5qdhqbzl" />
      </main>
      <Footer data-id="element-20" data-mp="3dkl60fx4dbm2" />
    </div>;
}